export enum MyPagesRoutesEnum {
  ADMIN = 'admin',
  BOOKINGS = 'bokningar',
  FAVOURITES = 'favoriter',
  MESSAGES = 'meddelanden',
  PROFILE = 'profil',
  SIGNUP = 'signup',
  LOGIN = 'login',
  BOOKING_CANCELLATION = 'avbokning',
  BOOKING_CANCELLATION_WITH_ID = 'avbokning/:bookingId',
  NOTFOUND = 'hittadesinte',
}
